import { ProductItem } from 'types/products.types';

import {
  ExtendedLocationPackageItem,
  LocalCartData,
  ProductItem as ProductItemType,
  ShopCartItem,
  ShopCartType,
  ShoppingCartResponse
} from '../types';

export const mapShopCartItemToProduct = (item: ShopCartItem): ProductItem => ({
  ...item,
  price: item.amount,
  base_price: item.base_price,
  qty: item.qty,
  size: item.size,
  item_type: item.item_type,
  pr_code: (item as any).pr_code || '',
  menu_id: (item as any).menu_id || 0,
  menu_name: (item as any).menu_name || '',
  category_id: (item as any).category_id || 0,
  category_name: (item as any).category_name || '',
  brand_id: item.brand_id || 0,
  brand_name: item.brand_name || '',
  price_range: '',
  pr_size: item.size || '',
  pr_color: '',
  pr_color_hex: null,
  pr_style_code: null,
  pr_style_id: null,
  style_name: null,
  allow_buying: 1,
  in_wishlist: 0,
  is_fav: 0,
  meta_title: '',
  meta_dscr: null,
  is_member_price: 0,
  member_price: 0,
  primary_pr_num: null,
  primary_img_url: '',
  primary_img_x2_url: '',
  primary_img_thumb_url: '',
  primary_img_2000_url: '',
  rating: { score: 0, review_cnt: 0 },
  slug_id: '',
  brand_slug_id: '',
  category_slug_id: '',
  avail_colors: [],
  avail_sizes: [],
  avail_in_store: [],
  recent_purchases: [],
  dscr_line_1: '',
  images: [],
  order_date: null,
  order_time: null,
  provider_id: null,
  provider_name: null,
  receipt_url: null
});

export const mapShopCartItemToPackage = (
  item: ShopCartItem
): ExtendedLocationPackageItem => ({
  ...item,
  price: item.amount,
  qty: item.qty,
  store_id: item.store_id || 0,
  price_orig: item.base_price || 0,
  name: item.name,
  category: '',
  dscr_line: item.dscr || null,
  tax_amt: 0,
  taxable: 0,
  pg_require: 0,
  pg_master_id: 0,
  is_pkg_master: 0,
  store_is_avail: 0,
  store_avail_list: '',
  amount: item.amount,
  amount_total: item.amount_total,
  amount_orig: item.base_price || 0
});

export const convertProductToCartItem = (
  product: ProductItemType
): ShopCartItem => ({
  cart_item_id: product.id,
  rel_cart_item_id: 0,
  id: product.id,
  item_type: product.item_type || ShopCartType.Product,
  name: product.name || '',
  dscr: product.dscr || '',
  brand_id: product.brand_id || 0,
  brand_name: product.brand_name || '',
  amount: product.price || 0,
  base_discount: 0,
  base_price: product.base_price || product.price || 0,
  qty: product.qty || 1,
  is_promo: 0,
  owner_id: 0,
  owner_name: '',
  amount_total: (product.price || 0) * (product.qty || 1),
  size: product.size || '',
  img: product.primary_img_thumb_url || product.primary_img_x2_url || '',
  is_electronic: 0,
  is_shippable: 1,
  store_id: 0,
  online_fulfillment: product?.online_fulfillment || 1
});

export const convertPackageToCartItem = (
  pkg: ExtendedLocationPackageItem
): ShopCartItem => ({
  cart_item_id: pkg.id,
  rel_cart_item_id: 0,
  id: pkg.id,
  item_type: ShopCartType.Package,
  name: pkg.name || '',
  dscr: pkg.dscr_line || '',
  brand_id: 0,
  brand_name: '',
  amount: pkg.price || 0,
  base_discount: 0,
  base_price: pkg.price_orig || pkg.price || 0,
  qty: pkg.qty || 1,
  is_promo: 0,
  owner_id: 0,
  owner_name: '',
  amount_total: (pkg.price || 0) * (pkg.qty || 1),
  size: '',
  img: '',
  is_electronic: 0,
  is_shippable: 0,
  store_id: pkg.store_id || 0,
  online_fulfillment: pkg?.online_fulfillment || 1
});

export const convertLocalItemsToCartData = (
  selectedProducts: ProductItemType[],
  selectedPackages: ExtendedLocationPackageItem[]
): LocalCartData => {
  const localItems: ShopCartItem[] = [
    ...selectedProducts.map(convertProductToCartItem),
    ...selectedPackages.map(convertPackageToCartItem)
  ];

  const totalCost = localItems.reduce(
    (sum, item) => sum + item.amount_total,
    0
  );
  return {
    items: localItems,
    payments: [],
    details: {
      invoice_id: 0,
      total_cost: totalCost,
      total_items_cost: totalCost,
      tax_cost: 0,
      shipping_cost: 0,
      is_pickup: 0,
      shipping_id: null,
      shipping_addr: {
        pickup_store_id: null,
        addr_id: null
      }
    }
  };
};

export const getCartData = (
  isAuthenticated: boolean,
  shopData: ShoppingCartResponse,
  selectedProducts: ProductItemType[],
  selectedPackages: ExtendedLocationPackageItem[]
): LocalCartData => {
  if (isAuthenticated) {
    return shopData as LocalCartData;
  }
  return convertLocalItemsToCartData(selectedProducts, selectedPackages);
};
